import React__default from 'react';
import { Layout, Icon } from './styles.js';
import { ReactComponent as SvgErrorAlertIcon } from '../../../assets/icons/error-alert-icon.svg.js';
import { useTheme, Typography } from '@mui/material';

function ZigAlertMessage(_a) {
    var text = _a.text, error = _a.error, warning = _a.warning, id = _a.id, _b = _a.variant, variant = _b === void 0 ? "body1" : _b;
    var palette = useTheme().palette;
    return (React__default.createElement(Layout, { id: id },
        React__default.createElement(Icon, null,
            React__default.createElement(SvgErrorAlertIcon, { height: "24px", width: "24px", color: error ? palette.redGraphOrError : warning ? palette.yellow : palette.neutral400 })),
        React__default.createElement(Typography, { variant: variant, sx: {
                color: error ? palette.redGraphOrError : warning ? palette.yellow : palette.neutral400,
            } }, text)));
}
var ErrorMessage = function (_a) {
    var text = _a.text, id = _a.id, _b = _a.variant, variant = _b === void 0 ? "body2" : _b;
    return React__default.createElement(ZigAlertMessage, { text: text, error: true, id: id, variant: variant });
};

export { ErrorMessage, ZigAlertMessage as default };
